import styled from 'styled-components';
export const UserBlock = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  > div:first-child {
    margin-right: 1em;
  }
  > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;
export const FakeLink = styled.span `
  color: var(--main-green-1);
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
//# sourceMappingURL=Header.js.map